import React, {Component} from 'react'
import logo from '../img/logo.png'
import '../styles/Header.css'
import {Link} from "react-router-dom";
import {Button} from "react-bootstrap";
import strings from '../strings/localeStrings'
import AppConfig from "../AppConfig";
import MapaMarcel from "../mapaMarcel/MapaMarcel";
import ReactModal from "react-modal";
import moment from "moment";
import WyszukiwarkaService from "../wyszukiwarka/WyszukiwarkaService";

export default class Header extends Component {

    constructor(props) {
        super(props);

        this.state = {
            collapsed: false,
            showModal: false,
            isTop: true,
            odliczanie: '',
            konfig: '',
            style: false
        }

    }

    componentDidMount() {
        WyszukiwarkaService.getKonfigWartosc('Ile minut w koszyku', 'Bilety')
            .then(function (response) {
                let res = response.data;
                this.setState({konfig: res})
            }.bind(this)).catch((e) => {
            console.log(e)
        });
        document.addEventListener('scroll', () => {
            const isTop = window.scrollY < 100;
            if (isTop !== this.state.isTop) {
                this.setState({isTop})
            }
        });
        if (JSON.parse(sessionStorage.getItem('koszyk')) !== null && JSON.parse(sessionStorage.getItem('koszyk')) !== undefined && JSON.parse(sessionStorage.getItem('koszyk')).length !== 0) {
            this.timer = setInterval(() => this.odliczanie(), 1000)
        }
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    styleChange() {
        if (this.state.style) {
            this.props.setStyle('')
        } else {
            this.props.setStyle('Contrast.css')
        }

        this.setState({style: !this.state.style})
    }

    showMap() {
        this.setState({showModal: true})
    }

    closeMap() {
        this.setState({showModal: false})
    }

    toggleNavbar() {
        this.setState({collapsed: !this.state.collapsed})
    }

    componentWillReceiveProps() {
        this.getStanKoszyka();
        if (JSON.parse(sessionStorage.getItem('koszyk')) !== null && JSON.parse(sessionStorage.getItem('koszyk')) !== undefined && JSON.parse(sessionStorage.getItem('koszyk')).length !== 0) {
            this.timer = setInterval(() => this.odliczanie(), 1000)
        }
    }

    iloscBiletow() {
        let koszyk = JSON.parse(sessionStorage.getItem('koszyk'));

        let ilosc = 0;

        for (let i = 0; i < koszyk.length; i++) {
            if (koszyk[i].idKuPrze !== null) {
                ilosc = ilosc + 2
            } else {
                ilosc++
            }
        }

        return ilosc;
    }

    odliczanie() {
        if (JSON.parse(sessionStorage.getItem('koszyk')) !== null && JSON.parse(sessionStorage.getItem('koszyk')) !== undefined && JSON.parse(sessionStorage.getItem('koszyk')).length !== 0) {
            let odliczanie = moment(moment(JSON.parse(sessionStorage.getItem('koszyk'))[0].id).add(this.state.konfig, 'minutes') - moment()).format('mm:ss');
            if (odliczanie === '00:00') {
                sessionStorage.removeItem('koszyk');
                sessionStorage.removeItem('koszykTimer');
                this.props.sesjaWygasla();
                this.setState({odliczanie: ''})
            } else {
                sessionStorage.setItem('koszykTimer', moment(moment(JSON.parse(sessionStorage.getItem('koszyk'))[0].id).add(this.state.konfig, 'minutes') - moment()));
                this.setState({odliczanie: odliczanie})
            }
        } else {
            this.setState({odliczanie: ''})
        }
    }

    getStanKoszyka() {
        return JSON.parse(sessionStorage.getItem('koszyk')) !== null && JSON.parse(sessionStorage.getItem('koszyk')) !== undefined ? this.iloscBiletow() : '0'
    }

    render() {
        return <div className={this.state.isTop ? "header-div" : "header-div-scrolled"}>
            <div className="container-fluid" style={{paddingRight: 0}}>
                <nav className="navbar navbar-fixed navbar-expand-custom navbar-light Header"
                     style={{paddingTop: 0, paddingBottom: 2}}>
                    <Link to='/'><a className="navbar-brand">
                        <img src={logo} className="logo"/>
                    </a></Link>
                    <button className="navbar-toggler" onClick={() => this.toggleNavbar()} type="button"
                            data-toggle="collapse"
                            data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                            aria-expanded="false"
                            aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"> </span>
                    </button>
                    <div className={this.state.collapsed ? 'collapse navbar-collapse show' : 'collapse navbar-collapse'}
                         id="navbarSupportedContent">
                        <ul className="navbar-nav navbar-left">
                            <li className="nav-item dropdown">
                                <Link className="nav-link dropdown-toggle" to="#" id="navbardrop"
                                      data-toggle="dropdown">
                                    Zaplanuj podróż
                                </Link>
                                <div className="dropdown-menu" onClick={() => this.toggleNavbar()}>
                                    <Link className="dropdown-item"
                                          to="/">Wyszukiwarka połączeń</Link>
                                    <Link className="dropdown-item"
                                          to="/mapa">Mapa połączeń lokalnych</Link>
                                    <Link className="dropdown-item"
                                          to="/rozklad">Rozkłady jazdy</Link>
                                    <Link className="dropdown-item"
                                          to="#" onClick={() => this.showMap()}>Lokalizacja autobusów</Link>
                                    <Link className="dropdown-item"
                                          to="/potwierdzenie-przejazdu">Potwierdzenie przejazdu</Link>
                                    <Link className="dropdown-item"
                                          to="/zwrot-biletu">Zwrot biletu</Link>
                                </div>
                            </li>
                            <li className="nav-item" onClick={() => this.toggleNavbar()}>
                                <Link className="nav-link" to="/aktualnosci">{strings.aktualnosci}</Link>
                            </li>
                            <li className="nav-item dropdown">
                                <Link className="nav-link dropdown-toggle" to="#" id="navbardrop"
                                      data-toggle="dropdown">
                                    Usługi
                                </Link>
                                <div className="dropdown-menu" onClick={() => this.toggleNavbar()}>
                                    <Link className="dropdown-item"
                                          to="/wynajem">Wynajem</Link>
                                </div>
                            </li>
                            <li className="nav-item dropdown">
                                <Link className="nav-link dropdown-toggle" to="#" id="navbardrop"
                                      data-toggle="dropdown">
                                    Firma
                                </Link>
                                <div className="dropdown-menu" onClick={() => this.toggleNavbar()}>
                                    <Link className="dropdown-item"
                                          to="/onas">O nas</Link>
                                    <Link className="dropdown-item"
                                          to="/nagrody">Nagrody</Link>
                                    <Link className="dropdown-item"
                                          to="/kontakt">Kontakt</Link>
                                    <a className="dropdown-item" target="_blank"
                                          href="https://marcel-sygnalista.topsa.com.pl/">Sygnalista</a>
                                </div>
                            </li>
                        </ul>
                        <ul className="navbar-nav ml-auto mgnRightNav">
                            {sessionStorage.getItem('loggedIn') === null ?
                                <li className="nav-item" onClick={() => this.toggleNavbar()}>
                                    <Link className="nav-link" to="/konto">{strings.mojeKonto}</Link>
                                </li> :
                                <li className="nav-item dropdown" style={{paddingLeft: 5, paddingRight: 5}}>
                                    <a className="nav-link dropdown-toggle" style={{paddingLeft: 0, paddingRight: 0}}
                                       href="#" id="navbardrop" data-toggle="dropdown">
                                        {JSON.parse(sessionStorage.getItem('loggedIn')).login.length > 24 ? JSON.parse(sessionStorage.getItem('loggedIn')).login.substr(0, 24) + '...' :
                                            JSON.parse(sessionStorage.getItem('loggedIn')).login}
                                    </a>
                                    <div className="dropdown-menu" style={{cursor: 'pointer'}}>
                                        <Link className="dropdown-item" to="/konto/bilety"
                                              onClick={() => this.toggleNavbar()}>{strings.mojeBilety}</Link>
                                        <Link className="dropdown-item" to="/konto/dane"
                                              onClick={() => this.toggleNavbar()}>{strings.daneKlienta}</Link>
                                        <Link className="dropdown-item" to="/konto/haslo"
                                              onClick={() => this.toggleNavbar()}>{strings.zmianaHasla}</Link>
                                        <Link className="dropdown-item" to="/konto/eventy"
                                              onClick={() => this.toggleNavbar()}>Eventy</Link>
                                        <Link className="dropdown-item" to="/konto/bok"
                                              onClick={() => this.toggleNavbar()}>BOK</Link>
                                        <Link className="dropdown-item" to="#" onClick={() => {
                                            this.toggleNavbar();
                                            sessionStorage.removeItem('loggedIn');
                                            sessionStorage.removeItem('koszyk');
                                            this.props.history.go('/')
                                        }}>{strings.wyloguj}</Link>
                                    </div>
                                </li>}
                            <li className="nav-item" style={{paddingRight: 0}} onClick={() => this.toggleNavbar()}>
                                {this.state.odliczanie ? <Link to='/koszyk'><Button
                                    style={{marginTop: 6, backgroundColor: '#eeb207', color: 'white'}}>
                                    <div>{strings.koszyk}
                                        &nbsp;({this.getStanKoszyka()})
                                    </div>
                                    <div style={{fontSize: '0.75rem'}}>{this.state.odliczanie}</div>
                                </Button>
                                </Link> : <Link to='/koszyk'><Button
                                    style={{marginTop: 16, backgroundColor: '#eeb207', color: 'white'}}>
                                    <div>{strings.koszyk}
                                        &nbsp;({this.getStanKoszyka()})
                                    </div>
                                </Button>
                                </Link>}
                            </li>
                            <li className="nav-item" style={{paddingLeft: 10, paddingRight: 0}}>
                                <div className="flags" style={{marginTop: 5}}>
                                    <div>&nbsp;</div>
                                    <div><a href="#" style={{color: '#999a99', fontSize: '1.25rem', paddingRight: 5}}
                                            onClick={() => document.body.style.fontSize = '1.5rem'}>A</a>
                                        <a href="#" style={{color: '#999a99', fontSize: '1rem', paddingRight: 5}}
                                           onClick={() => document.body.style.fontSize = '1.25rem'}>A</a>
                                        <a href="#" style={{color: '#999a99', fontSize: '0.75rem', paddingRight: 10}}
                                           onClick={() => document.body.style.fontSize = '1rem'}>A</a>
                                        <i className="fa fa-adjust" onClick={() => this.styleChange()}
                                           style={{color: '#999a99', paddingRight: 5}}/></div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </nav>
            </div>
            <ReactModal
                isOpen={this.state.showModal}
                contentLabel="Minimal Modal Example"
                ariaHideApp={false}
            >
                <div className="row">
                    <div className="col-sm-12 text-right mapaModal" style={{marginBottom: '5px'}}>
                        <Button bsStyle={'danger'} bsSize={'small'} onClick={this.closeMap.bind(this)}>
                            <i className="fa fa-times" style={{color: 'white'}}> </i>
                        </Button>
                    </div>
                </div>
                <MapaMarcel/>
            </ReactModal>
        </div>

    }
}



// WEBPACK FOOTER //
// ./src/components/shared/Header.js